/** Where a club's logo is served. The address carries the first 12 characters of the logo's hash, so a new logo is a new address and
 * the browser may keep the old one for good. Public: an <img> needs no sign-in header. `size="small"` is the sidebar variant. */
export function clubLogoUrl(slug: string, sha256: string | null | undefined, size: "full" | "small" = "full"): string | null {
  if (!sha256) return null;
  const base = import.meta.env.VITE_API_BASE_URL ?? "/api/v1";
  return `${base}/clubs/${encodeURIComponent(slug)}/logo?${size === "small" ? "size=small&" : ""}v=${sha256.slice(0, 12)}`;
}

/** What the sidebar and the browser tab call the club: the brand name, else the club's name, else the product's own name (which is
 * all there is before the club is known). */
export function displayName(club: { brand_name?: string | null; name?: string | null } | null | undefined, product: string): string {
  return club?.brand_name?.trim() || club?.name?.trim() || product;
}
